import React from "react";
import { Grid } from "@material-ui/core";

import LayoutHeaderTitle from "components/LayoutHeaderTitle";
import AuthWrapper from "components/AuthWrapper";
import ClientFilter from "./ClientFilter";

const HeaderComponents = [
  <Grid item xs={3} md={3} lg={6}>
    <LayoutHeaderTitle title={"Dashboard"} />
  </Grid>,
  <Grid item xs={12}>
    <ClientFilter />
  </Grid>,
];

export default HeaderComponents;
